import React, { useState } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';
import type { NavigationItem } from '@shared/types/ui-components';

interface TreeItemProps {
  item: NavigationItem;
  level?: number;
  selectedId: string;
  onSelect: (id: string) => void;
}

export const TreeItem: React.FC<TreeItemProps> = ({ item, level = 0, selectedId, onSelect }) => {
  const [isOpen, setIsOpen] = useState(true);
  const isSelected = item.id === selectedId;
  const hasChildren = item.children && item.children.length > 0;

  return (
    <div className="select-none">
      <div
        className={`flex items-center px-3 py-1.5 cursor-pointer hover:bg-dark-surface/50 text-xs transition-all duration-150 ${isSelected ? 'bg-brand-600 text-white' : 'text-dark-muted hover:text-dark-text'}`}
        style={{ paddingLeft: `${level * 16 + 12}px` }}
        onClick={() => onSelect(item.id)}
      >
        <span
          className="mr-1.5 p-0.5 rounded hover:bg-white/10"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          {hasChildren ? (
            isOpen ? <ChevronDown size={10} /> : <ChevronRight size={10} />
          ) : <span className="w-2.5 inline-block" />}
        </span>
        <span className="flex-1 truncate font-medium">{item.label}</span>
      </div>
      {isOpen && hasChildren && (
        <div>
          {item.children!.map((child: NavigationItem) => (
            <TreeItem key={child.id} item={child} level={level + 1} selectedId={selectedId} onSelect={onSelect} />
          ))}
        </div>
      )}
    </div>
  );
};
